Stable identifier of the position in your software.
